// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinCodeDisplay_container__1qlQv","reset-button":"JoinCodeDisplay_reset-button__3f7YV","resetButton":"JoinCodeDisplay_reset-button__3f7YV"};